module.exports = __webpack_public_path__ + "static/media/text-manipulation-icon.2cd1efcc.svg";